(function () {
  'use strict';

  /* ── Gallery ── */
  var images   = window.__galleryImages || [];
  var currentIdx = 0;
  var mainImg  = document.getElementById('main-product-img');
  var thumbItems = document.querySelectorAll('.thumb-item');

  function gallerySelect(idx) {
    currentIdx = (idx + images.length) % images.length;
    if (mainImg && images[currentIdx]) mainImg.src = images[currentIdx];
    thumbItems.forEach(function (t, i) {
      t.classList.toggle('active', i === currentIdx);
      if (i === currentIdx) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
  }

  thumbItems.forEach(function (t) {
    t.addEventListener('click', function () { gallerySelect(parseInt(t.dataset.index, 10)); });
  });

  var galleryPrev = document.getElementById('gallery-prev');
  var galleryNext = document.getElementById('gallery-next');
  if (galleryPrev) galleryPrev.addEventListener('click', function () { gallerySelect(currentIdx - 1); });
  if (galleryNext) galleryNext.addEventListener('click', function () { gallerySelect(currentIdx + 1); });

  /* ── Lightbox ── */
  var lightbox    = document.getElementById('lightbox');
  var lightboxImg = document.getElementById('lightbox-img');

  var galleryEnlarge = document.getElementById('gallery-enlarge');
  if (galleryEnlarge) {
    galleryEnlarge.addEventListener('click', function () {
      if (lightboxImg && mainImg) lightboxImg.src = mainImg.src;
      if (lightbox) lightbox.classList.add('open');
    });
  }

  var lightboxClose = document.getElementById('lightbox-close');
  if (lightboxClose) lightboxClose.addEventListener('click', function () { lightbox.classList.remove('open'); });

  var lightboxPrev = document.getElementById('lightbox-prev');
  if (lightboxPrev) {
    lightboxPrev.addEventListener('click', function () {
      gallerySelect(currentIdx - 1);
      if (lightboxImg && mainImg) lightboxImg.src = mainImg.src;
    });
  }

  var lightboxNext = document.getElementById('lightbox-next');
  if (lightboxNext) {
    lightboxNext.addEventListener('click', function () {
      gallerySelect(currentIdx + 1);
      if (lightboxImg && mainImg) lightboxImg.src = mainImg.src;
    });
  }

  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) lightbox.classList.remove('open');
    });
  }

  /* ── Short description: clamp with fade + Read more/less toggle ── */
  var descCard = document.getElementById('short-desc-card');
  if (descCard) {
    var descClip     = document.getElementById('short-desc-clip');
    var descFade     = document.getElementById('short-desc-fade');
    var descToggle   = document.getElementById('short-desc-toggle');
    var collapsedMax = getComputedStyle(descClip).maxHeight;
    var descExpanded = false;

    /* Only show the fade/toggle if the text actually overflows the clip */
    if (descClip.scrollHeight <= descClip.clientHeight + 2) {
      descFade.style.display = 'none';
      descToggle.hidden = true;
    } else if (descToggle) {
      descToggle.addEventListener('click', function () {
        descExpanded = !descExpanded;
        if (descExpanded) {
          descClip.style.maxHeight = descClip.scrollHeight + 'px';
          descCard.classList.add('expanded');
          descToggle.textContent = 'Read less';
        } else {
          descClip.style.maxHeight = collapsedMax;
          descCard.classList.remove('expanded');
          descToggle.textContent = 'Read more';
        }
      });
    }
  }

  /* ── Qty control ── */
  var qty    = 1;
  var qtyVal = document.getElementById('qty-val');

  var qtyDec = document.getElementById('qty-dec');
  var qtyInc = document.getElementById('qty-inc');

  if (qtyDec) qtyDec.addEventListener('click', function () { if (qty > 1) { qty--; qtyVal.textContent = qty; } });
  if (qtyInc) qtyInc.addEventListener('click', function () { qty++; qtyVal.textContent = qty; });

  /* ── Tabs ── */
  var tabBtns   = document.querySelectorAll('.tab-btn');
  var tabPanels = document.querySelectorAll('.tab-panel');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.tab;
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      tabPanels.forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById('tab-' + target);
      if (panel) panel.classList.add('active');
    });
  });

  /* ── Variant switching ── */
  var variants       = window.__productVariants || [];
  var weightSelect   = document.querySelector('.weight-select');
  var priceOrigEl    = document.querySelector('.price-original');
  var priceCurrentEl = document.querySelector('.price-current');
  var skuEl          = document.getElementById('product-sku');

  function formatMoney(cents) {
    return 'Rs ' + (cents / 100).toLocaleString('en-PK', { maximumFractionDigits: 0 });
  }

  function updateVariantUI(variantId) {
    var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
    if (!variant) return;

    /* Price */
    if (priceCurrentEl) priceCurrentEl.textContent = formatMoney(variant.price);
    if (priceOrigEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceOrigEl.textContent = formatMoney(variant.compare_at_price);
        priceOrigEl.style.display = '';
      } else {
        priceOrigEl.style.display = 'none';
      }
    }

    /* SKU */
    if (skuEl) skuEl.textContent = variant.sku || '—';

    /* URL — update without reload */
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    /* Gallery — switch to variant image if it has one */
    if (variant.featured_image && images.length > 0) {
      var varImgSrc = variant.featured_image.src;
      var matchIdx  = images.findIndex(function (src) { return src === varImgSrc; });
      if (matchIdx > -1) gallerySelect(matchIdx);
    }

    /* Add to cart button data attr + sold-out state */
    var addBtn = document.getElementById('add-cart-btn');
    if (addBtn) {
      addBtn.dataset.variantId = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    /* Buy Now — hidden entirely when the selected variant is sold out */
    var buyNowBtn = document.getElementById('buynow-btn');
    if (buyNowBtn) {
      buyNowBtn.disabled = !variant.available;
      buyNowBtn.style.display = variant.available ? '' : 'none';
    }
  }

  if (weightSelect) {
    weightSelect.addEventListener('change', function () {
      updateVariantUI(weightSelect.value);
    });
    /* Init with preselected variant */
    updateVariantUI(weightSelect.value);
  }

  /* ── Clear variant selection ── */
  var clearVariantLink = document.getElementById('clear-variant');
  if (clearVariantLink) {
    clearVariantLink.addEventListener('click', function (e) {
      e.preventDefault();
      if (weightSelect) { weightSelect.selectedIndex = 0; updateVariantUI(weightSelect.value); }
    });
  }

  /* ── Add to cart ── */
  var addCartBtn = document.getElementById('add-cart-btn');
  if (addCartBtn) {
    addCartBtn.addEventListener('click', function () {
      var variantId = addCartBtn.dataset.variantId;
      if (!variantId) return;
      /* Delegate to the single shared add-to-cart function in tov-header.js */
      window.tovAddToCart(variantId, qty, addCartBtn);
    });
  }

  /* ── Buy now: same shared add-to-cart function, then straight to checkout ── */
  var buyNowBtn = document.getElementById('buynow-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      var variantId = addCartBtn ? addCartBtn.dataset.variantId : null;
      if (!variantId) return;
      window.tovAddToCart(variantId, qty, buyNowBtn, { openDrawer: false })
        .then(function () {
          window.location.href = ((window.Theme && Theme.routes.root_url) || '/') + 'checkout';
        })
        .catch(function () {});
    });
  }

  /* ── Product nav hover preview (desktop / hover-capable devices only) ── */
  var navPreview = document.getElementById('product-nav-preview');
  if (navPreview && window.matchMedia('(hover: hover)').matches) {
    var pnpImg   = navPreview.querySelector('.pnp-img');
    var pnpTitle = navPreview.querySelector('.pnp-title');
    var pnpPrice = navPreview.querySelector('.pnp-price');
    var PREVIEW_W = 160;

    document.querySelectorAll('.product-nav-btn[data-preview-title]').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        var img   = btn.dataset.previewImg   || '';
        var title = btn.dataset.previewTitle || '';
        var price = btn.dataset.previewPrice || '';

        if (img) { pnpImg.src = img; pnpImg.style.display = ''; }
        else      { pnpImg.style.display = 'none'; }
        pnpTitle.textContent = title;
        pnpPrice.textContent = price;

        var rect = btn.getBoundingClientRect();
        navPreview.style.top = (rect.bottom + 8) + 'px';

        /* Align left edge of preview to left edge of button,
           but nudge left if it would overflow the viewport right edge */
        var leftPos = rect.left;
        if (leftPos + PREVIEW_W > window.innerWidth - 16) {
          leftPos = rect.right - PREVIEW_W;
        }
        navPreview.style.left = leftPos + 'px';

        navPreview.classList.add('visible');
      });

      btn.addEventListener('mouseleave', function () {
        navPreview.classList.remove('visible');
      });
    });
  }

  /* ── Share button (Web Share API with clipboard fallback) ── */
  var shareBtn = document.querySelector('.share-btn[data-action="share"]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: document.title, url: window.location.href });
      } else {
        navigator.clipboard && navigator.clipboard.writeText(window.location.href);
      }
    });
  }


})();
